import React from 'react';
import PropTypes from 'prop-types';
import { commitMutation, graphql } from 'react-relay';
import { trackEvent } from 'dibs-tracking';
import { SAVE_ITEM_PDP_FLOW } from '../../authModal/authentication/authFlowConstants';
import getRelayEnvironment from '../../relayClientEnvironment';
import AutoModal from './AutoModal';
import authModalLoader from '../../utils/AuthModalLoader';
import { getEverLoggedIn, getUserId } from 'dibs-cookie-jar';
import copy from '../copy/checkoutAutoModalCopy.json';

const label = 'abandoned fp checkout - item favoriting';

const mutation = graphql`
    mutation CheckoutAutoModalMutation(
        $input: ModifyPortfolioItemsInput!
    ) {
        modifyPortfolioItems(input: $input) {
            clientMutationId
        }
    }
`;

const trackItemFavorited = () => {
    trackEvent({
        category: 'item favoriting',
        action: 'item added',
        label
    });
};

const itemAddingFailure = errors => {
    console.error('Item was not added to HEART portfolio.', errors);
};

const addItemToHeartPortfolio = ({ itemId, userId }) => {
    const input = {
        action: 'ADD',
        portfolioType: 'HEART',
        userId,
        itemsIds: [itemId]
    };

    commitMutation(
        getRelayEnvironment(),
        {
            mutation,
            variables: { input },
            onCompleted: (payload, errors) => {
                if (errors) {
                    itemAddingFailure(errors);
                    return;
                }
                trackItemFavorited();
            },
            onError: (error) => {
                itemAddingFailure([error]);
            }
        }
    );
};

const authModalShow = ({ item, email}) => {
    const id = getUserId(document.cookie);
    if (!id) {
        authModalLoader.show({
            action: getEverLoggedIn(document.cookie) ? authModalLoader.constants.LOGIN : authModalLoader.constants.REGISTER,
            flow: SAVE_ITEM_PDP_FLOW,
            ga: label,
            additionalProps: {},
            email: email
        }).then(({ userId }) => {
            addItemToHeartPortfolio({ itemId: item.id, userId });
        });
    } else {
        addItemToHeartPortfolio({ itemId: item.id, id });
    }
};

const CheckoutAutoModal = ({ item, email }) => (
    <AutoModal
        copy={copy}
        item={item}
        onCtaClick={() => {
            authModalShow({ item, email });
        }}
        tracking={{
            category: 'promo interaction',
            action: label,
            label
        }}
    />
);

CheckoutAutoModal.propTypes = {
    item: PropTypes.object,
    email: PropTypes.string
};

export default CheckoutAutoModal;



// WEBPACK FOOTER //
// ./src/abandonedCheckout/components/CheckoutAutoModal.jsx